// Feed excerpt cleanup.
//
// Ghost precomputes each post's excerpt server-side by flattening the HTML to
// plaintext, so footnote apparatus survives into it as literal text: refs as
// "vise[1]", inline notes as "{a note}". No template helper can filter that
// field, but the feed runs this bundle — so scrub it here: braces become the
// parenthetical the note degrades to everywhere else, ref markers vanish, and
// a brace left dangling by the ~500-char cap is dropped. No-JS readers see
// the raw markers; that is the accepted floor.
export default function feedNotes() {
    const feed = document.querySelector(".gh-postfeed");
    if (!feed) return;

    const scrub = (root) => {
        root.querySelectorAll(".gh-lead-excerpt, .gh-lrow-excerpt").forEach(
            (excerpt) => {
                // Text nodes only — the (Continued) link rides inside this <p>.
                const walker = document.createTreeWalker(
                    excerpt,
                    NodeFilter.SHOW_TEXT
                );
                for (let n = walker.nextNode(); n; n = walker.nextNode()) {
                    const t = n.nodeValue
                        .replace(/\{([^{}]*)\}/g, "($1)")
                        .replace(/\[\d{1,3}\]/g, "")
                        .replace(/[{}]/g, "");
                    if (t !== n.nodeValue) n.nodeValue = t;
                }
            }
        );
    };

    scrub(feed);

    // Infinite scroll appends more cards later; scrub those as they arrive.
    // (Scrubbing only rewrites text nodes, so it can't retrigger childList.)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
            m.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) scrub(node);
            });
        });
    });
    observer.observe(feed, { childList: true, subtree: true });
}
